/**
 * The one `gtag` shim, shared by consent.ts, gtm.ts and events.ts.
 *
 * It pushes the raw `arguments` object — NOT a rest array. Google's canonical
 * snippet is `function gtag(){dataLayer.push(arguments);}`, and gtag.js reads
 * command tuples as arguments objects. `dataLayer.push(['config', id])` looks
 * equivalent and is not: it is a reliable way to get no GA4 config at all.
 */

declare global {
  interface Window {
    // `unknown[]`, not `Record<string, unknown>[]`: gtag pushes an `arguments`
    // object while GTM pushes plain objects. Both share this one array.
    dataLayer: unknown[];
  }
}

/** `_args` exists only to type the call sites; the body uses `arguments`. */
export function gtag(..._args: unknown[]): void {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}
